// extracted by mini-css-extract-plugin
export default {"rowBackground":"WhatWeDoStyle_rowBackground__+wZ4h","imgSize":"WhatWeDoStyle_imgSize__k76kb"};